import Vue from 'vue'
import Vuex from 'vuex'

import transferModule from './store_transfers';

Vue.use(Vuex);

var audio = new Audio(require('@/assets/beep-10.mp3'));

export default new Vuex.Store({
    modules: {
        transfer: transferModule,
    },
    state: {
        token: '',
        listModelNumbers: null,
        loading: false,
        lastResult: '',
        searchResult: null,
        snChecked: {},
        validWorker: '',
        validSO: {},
        validSOprn: {},
        lastShipState: null,
        validUser: '',
        lastScanProductCountToday: null,
        checkedIC: null,
        inventorySNs: [],
        actField: null,
        already: null,
        allInvenWaves: null,
        activeInvenWaves: null,
        prefixes: [],
        errorDialog: null,
        selectedWaveID: null,
        printTpl: [],
        serverMaxSuffix: null,
    },
    getters: {
        prefixes: state => state.prefixes,
        isAuthenticated: state => !!state.token,
        actField: (state) => {
            return state.actField
        }
    },
    mutations: {
        saveIWave(state, d) {
              if (d) {
                  state.selectedWaveID = d;
              } else {
                  state.selectedWaveID = null;
                  state.inventorySNs = [];
                  state.already = null;
              }
        },
        logout(state) {
            state.token = '';
            // sessionStorage.removeItem("token");
        },
        setToken(state, token) {
            state.token = token;
            console.log('token set');
            // sessionStorage.setItem("token", token);
            axios.defaults.headers.common['Authorization'] = token;
        },
        setModelNumberList(state, list) {
            if (list && list.numrows > 0)
                state.listModelNumbers = list.rows;
            else
                state.listModelNumbers = null;
            if (list && list.hasOwnProperty('unserialized') && list.unserialized === 1) {
                this.commit('showMessage', {type: 'error', msg: "Item found as UNSERIALIZED ItemCode!"});
            }
        },
        clearErrorDialog(state) {
            state.errorDialog = null;
        },
        showDialog(state, msg) {
            state.errorDialog = { msg: msg.msg, ts: Date.now() };
        },
        showMessage(state, msg) {
            state.lastResult = {msg: msg.msg, type: msg.type, ts: Date.now()};
            if (msg.type === "error" && !msg.sound) // je to error, ale nema svuj vlastni zvuk
                audio.play(); // sound "BLEEEP :(" - default sound pro error
        },
        setSearchResult(state, data) {
            state.searchResult = data;
        },
        setSNstate(state, data) {
            state.lastScanProductCountToday = data.todayscount;
            Vue.set(state.snChecked, data.sn, {
                status: data.status,
                poNum: data.poNum,
                validSN: data.validSN,
                iC: data.iC
            });
        },
        saveWorker(state, worker) {
            state.validWorker = worker;
        },

        setSOdata(state, d) {
            state.validSO = d;
            state.lastShipState = null;
        },
        setSOprndata(state, d) {
            state.validSOprn = d;
        },
        setShipSNdata(state, d) {
            if (d == null) {
                state.lastShipState = null;
            } else {
                state.validSO.done[d.itemCode] = d.count;
                state.lastShipState = d;
            }
        },
        setIC(state, d = null) {
            state.checkedIC = d;
            if (d) {
                state.actField = 'quantity';
                state.already = {already: d.already, iC: d.iC};
            } else
                state.actField = 'snfld';
        },
        addInventorySN(state, d) {
            state.inventorySNs.push(d);
            state.already = {already: d.already, iC: d.iC};
        },
        setAllInvenWaves(state, d) {
            state.allInvenWaves = d;
        },
        setActiveInvenWaves(state, d) {
            state.activeInvenWaves = d;
        },
        updateCSN(state, d) {
            state.validSO.done[d.itemCode] = d.count;
            state.lastShipState = d;
        },
        setPrefixes(state, prf) {
            state.prefixes = prf;
        },
        setPrintTemplates(state, tpl) {
            state.printTpl = tpl;
        },
        setMaxSuffix(state, d) {
            state.serverMaxSuffix = d.max;
        }
    },
    actions: { // DISPATCH
        getMaxSuffix(context, prefix) {
            axios.get('/getMaxSuffix/?prefix=' + prefix)
                .then(response => {
                    context.commit('setMaxSuffix', response.data);
                })
                .catch(e => {
                    context.commit('showMessage', {msg: 'Server Error ' + e.toString(), type: 'error'});
                });

        },
        getPrefix(context) {
            axios.get('/getPrefixes')
                .then(response => {
                    context.commit('setPrefixes', response.data);
                })
                .catch(e => {
                    context.commit('showMessage', {msg: 'Server Error ' + e.toString(), type: 'error'});
                });
        },
        testcall(context) {
            axios.post('/test');
        },
        async login(context, d) {
            await axios.post('/login', d)
                .then(r => {
                    if (r.data && r.data.token) {
                        context.commit('setToken', r.data.token);
                        context.commit('saveWorker', r.data.worker);
                    } else
                        throw 'login failed';
                })
                .catch(e => {
                    throw e;
                });
        },
        invenChStatus(context, d) {
            axios.post('/postInvenStatus', d)
                .then(
                    () => {
                        this.dispatch('invenWaves');
                    }
                );
        },
        invenActiveWaves(context) {
            axios.get('/getActiveInvenWaves')
                .then(response => {
                    context.commit('setActiveInvenWaves', response.data);
                })
                .catch(e => {
                    context.commit('showMessage', {msg: 'Server Error ' + e.toString(), type: 'error'});
                });

        },
        invenWaves(context) {
            context.state.loading = true;
            axios.get('/getInvenWaves')
                .then(response => {
                    context.state.loading = false;
                    context.commit('setAllInvenWaves', response.data);
                })
                .catch(e => {
                    context.state.loading = false;
                    context.commit('showMessage', {msg: 'Server Error ' + e.toString(), type: 'error'});
                });
        },
        invenNewWave(context, ndate) {
            axios.post('/invenNewWave', ndate)
                .then(response => {
                    this.dispatch('invenWaves');
                });
        },
        invenScanBarcode(context, data) {
            if (data) {
                context.state.loading = true;
                axios.post('/invenScan', data)
                    .then(response => {
                        context.state.loading = false;
                        if (response.data.sound) {
                            var audio = new Audio('./mp3/' + response.data.sound);
                            audio.play();
                        }
                        if (response.data.validSN) {
                            context.commit('addInventorySN', response.data);
                        }
                        if (response.data.error) {
                            context.commit('showMessage', response.data.error);
                        }

                        if (response.data.setIC)
                            context.commit('setIC', response.data.setIC);
                        else
                            context.commit('setIC');
                    })
                    .catch(e => {
                        context.state.loading = false;
                        context.commit('showMessage', {msg: 'Server Error ' + e.toString(), type: 'error'});
                    });
            }
        },
        checkModelNumber(context, model) {
            context.commit('setModelNumberList');
            if (model.length) {
                axios.post('/getModelsByMask',  { ic: model })
                    .then(response => {
                        context.commit('setModelNumberList', response.data);
                    });
            }
        },
        createNewSerials(context, data) {
            if (data) {
                context.state.loading = true;
                axios.post('/createSerials', data)
                    .then(response => {
                        context.state.loading = false;
                        context.commit('showMessage', response.data);
                        if (response.data.ids && response.data.ids.length > 0)
                            context.dispatch('searchSerials', {"ids": response.data.ids});
                    });
            }
        },
        searchSerials(context, data) {
            if (data) {
                context.state.loading = true;
                axios.post('/searchSerials2', data)
                    .then(response => {
                        context.state.loading = false;
                        context.commit('showMessage', response.data.status);
                        context.commit('setSearchResult', response.data.tabledata);
                    });
            }
        },
        downloadPDF(context, r) {
            if (r && r.serials && (r.template || r.templateName)) {
                context.state.loading = true;
                axios.post('/downloadPDF', r, {responseType: 'arraybuffer'})
                    .then(response => {
                        context.state.loading = false;
                        var blob = new Blob([response.data], {type: 'application/pdf'});
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.target = '_blank';
                        var dt = new Date();
                        if (r.download) {
                            if (r.templateName) {
                                link.download = r.templateName + '-' + dt.getMinutes() + dt.getSeconds() + ".PDF";
                            } else {
                                link.download = "Template-" + r.template + '-' + dt.getMinutes() + dt.getSeconds() + ".PDF";
                            }
                        }
                        link.click();
                    });
            }
        },
        getPrintTemplates(context) {
            axios.get('/getPrintTemplates')
                .then(response => {
                    if (response.data) {
                       context.commit('setPrintTemplates', response.data);
                    }
                });
        },
        assignCSN(context, data) {
            axios.post('/assignSN', data)
                .then(response => {
                    if (response.data) {
                        if (response.data.error) {
                            context.commit('showMessage', response.data.error);
                            if (response.data.error.sound) {
                                var audio = new Audio('./mp3/' + response.data.error.sound);
                                audio.play();
                            }
                        } else {
                            if (response.data.sound) {
                                var audio = new Audio('./mp3/' + response.data.sound);
                                audio.play();
                            }
                            context.commit('updateCSN', response.data);
                        }
                    }
                });
        },
        validateSN(context, sn) {
            if (sn) {
                axios.post('/produceSN', sn)
                    .then(response => {
                        if (response.data) {
                            context.commit('setSNstate', response.data);
                            if (response.data.sound) {
                                var audio = new Audio('./mp3/' + response.data.sound);
                                audio.play();
                            }
                        }
                    });
            }
        },
        validateSO(context, so) {
            context.commit('setSOdata', {});
            if (so) {
                axios.get('/getSOdata/' + so)
                    .then(response => {
                        if (response.data) {
                            if (response.data.error) {
                                context.commit('showMessage', response.data.error);
                                if (response.data.error.sound) {
                                    var audio = new Audio('./mp3/' + response.data.error.sound);
                                    audio.play();
                                }
                            } else
                                context.commit('setSOdata', response.data);
                        }
                    });
            }
        },
        validateSOforDLV(context, so) {
            context.commit('setSOprndata', {});
            if (so) {
                axios.get('/getSOforprint/' + so)
                    .then(response => {
                        if (response.data) {
                            if (response.data.error) {
                                context.commit('showMessage', response.data.error);
                            } else
                                context.commit('setSOprndata', response.data);
                        }
                    });
            }
        },
        clearManufactured(context, items) {
            if (items) {
                axios.post('/clearProdDate', items.ids)
                    .then(() => {
                        this.dispatch('searchSerials', items.filter);
                    });
            }
        },
        saveComment(context, d) {
            if (d.ids) {
                axios.post('/saveComment', d)
                    .then(response => {
                        context.commit('showMessage', response.data);
                    });
            }
        },
        updateProdOrder(context, d) {
            if (d.ids) {
                axios.post('/updateProdOrder', d)
                    .then(response => {
                        context.commit('showMessage', response.data);
                    });
            }
        },
        clearShipped(context, items) {
            if (items) {
                axios.post('/clearShipDate', items.ids)
                    .then(() => {
                        this.dispatch('searchSerials', items.filter);
                    });
            }

        },
        deactivate(context, items) {
            if (items) {
                axios.post('/deactivate', items.ids)
                    .then(() => {
                        this.dispatch('searchSerials', items.filter);
                    });
            }

        },
        markPrinted(context, sn) {
            if (sn)
                axios.post('/markPrinted', sn);
        },
        shipSN(context, d) {
            context.commit('setShipSNdata', null);
            if (d.sn && d.so)
                axios.post('/shipSN', d)
                    .then(response => {
                        if (response.data) {
                            //K16-1767
                            if (response.data.error) {
                                if (response.data.error.type == 'error') {
                                    context.commit('showDialog', response.data.error);
                                    let audio = new Audio('./mp3/alarm.mp3');
                                    audio.onended = () => {
                                        if (response.data.error.sound) {
                                            var audio2 = new Audio('./mp3/' + response.data.error.sound);
                                            audio2.play();
                                        }
                                    };
                                    audio.play();
                                } else {
                                    context.commit('showMessage', response.data.error);
                                    if (response.data.error.sound) {
                                        var audio = new Audio('./mp3/' + response.data.error.sound);
                                        audio.play();
                                    }
                                }
                            } else {
                                context.commit('setShipSNdata', response.data);
                            }
                        }
                    });
        },


    },
})
